import { render, staticRenderFns } from "./tableHeadSortable.vue?vue&type=template&id=e7700084&"
import script from "./tableHeadSortable.vue?vue&type=script&lang=js&"
export * from "./tableHeadSortable.vue?vue&type=script&lang=js&"
import style0 from "./tableHeadSortable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports